import { get, patch, post, put } from './http';
import Vue from 'vue';

const enviroment = process.env.NODE_ENV === 'development' ? '-dev' : '';
const baseUrl = `https://api${enviroment}.washout-app.com`;
const adminBaseUrl = `https://admin${enviroment}.washout-app.com/api/v1`;
const servicesBaseUrl = `https://service${enviroment}.washout-app.com`;

const urlEnv = !process.env.APP_NAME
  ? 'dev-'
  : process.env.APP_NAME.startsWith('PROD')
  ? 'prod-'
  : process.env.APP_NAME.startsWith('QA')
  ? 'qa-'
  : 'dev-';

const UserMSBaseUrl = `https://${urlEnv}userms.washout-app.com`;
const VehicleMSBaseUrl = `https://${urlEnv}vehiclems.washout-app.com`;
const WashingMSBaseUrl = `https://${urlEnv}washingms.washout-app.com`;
const LocationMSBaseUrl = `https://${urlEnv}locationms.washout-app.com`;

const washout2TimeAvailabilities = `https://${
  urlEnv === '-dev' ? 'dev-' : 'prod-'
}locationms.washout-app.com/TankAvailability/old-washout/TimeAvailabilities`;

const washout2Username = '';
const washout2ClientScret = '';

const $getZoneByCoords = ({ latitude, longitude }) => {
  return get(
    `${baseUrl}/Zones/getZoneByCoords?lat=${latitude}&lng=${longitude}`
  );
};
const $getWashersByZone = ({ zoneId, date, duration = 100 }) => {
  return get(
    `${baseUrl}/Clients/washerForWashing?zoneid=${zoneId}&time=${new Date(
      date
    ).toISOString()}&duration=${duration}&type=booking`
  );
};
const $getWashersByZoneWashOut2 = ({ zoneId, date, executionTime }) => {
  const token =
    'Basic ' +
    Buffer.from(washout2Username + ':' + washout2ClientScret).toString(
      'base64'
    );
  return post(
    washout2TimeAvailabilities,
    {
      date: new Date(date).toISOString(),
      zoneId: zoneId,
      executionTime: executionTime
    },
    token
  );
};

const $getCities = async countryId => {
  const recaptcha = await Vue.prototype.$recaptcha('wowebsite');
  return get(`${LocationMSBaseUrl}/Location/Cities`, null, recaptcha);
};

const $getBrands = async () => {
  const recaptcha = await Vue.prototype.$recaptcha('wowebsite');
  return get(`${VehicleMSBaseUrl}/Vehicle/Brands`, null, recaptcha);
};

const $getModelsByBrandId = async brandId => {
  const recaptcha = await Vue.prototype.$recaptcha('wowebsite');
  return get(
    `${VehicleMSBaseUrl}/Vehicle/${brandId}/VehicleModels`,
    null,
    recaptcha
  );
};
const $getVehicleTypes = async () => {
  const recaptcha = await Vue.prototype.$recaptcha('wowebsite');
  return get(`${VehicleMSBaseUrl}/Vehicle/Types`, recaptcha);
};
const $getPrices = () => {
  return get(`${baseUrl}/Prices`);
};
const $getPackagesAndServices = async (vehicleModelId, countryId, cityId) => {
  const recaptcha = await Vue.prototype.$recaptcha('wowebsite');
  return get(
    `${WashingMSBaseUrl}/PackagePrice/Users/VehicleModel/${vehicleModelId}/PackagesAndServices?countryId=${countryId}&cityId=${cityId}`,
    null,
    recaptcha
  );
};
const $getCountries = async () => {
  const recaptcha = await Vue.prototype.$recaptcha('wowebsite');
  return get(`${LocationMSBaseUrl}/Location/Countries`, null, recaptcha);
};

const $getNations = () => {
  return get(`${baseUrl}/Nations`);
};
const $getProvinces = () => {
  return get(`${baseUrl}/Provinces`);
};
const $postRegistration = payload => {
  return post(`${baseUrl}/Clients`, payload);
};
const $patchRegistration = (payload, userId, token) => {
  return patch(`${baseUrl}/Clients/${userId}`, payload, token);
};
const $postLogin = payload => {
  return post(`${baseUrl}/Clients/login`, payload);
};
const $refreshToken = token => {
  return post(`${baseUrl}/Clients/refreshTokens`, { refreshToken: token });
};
const $getAuthToken = id => {
  return get(`${baseUrl}/ClientAccessTokens/${id}`, id);
};

const $verifyEmailRequest = token => {
  return post(`${baseUrl}/Clients/verify-email-request`, {}, token);
};
const $verifyPhoneRequest = token => {
  return post(`${baseUrl}/Clients/verify-phone-request`, {}, token);
};
const $verifyEmailCode = (payload, token) => {
  return post(`${baseUrl}/Clients/email-verification`, payload, token);
};
const $verifyPhoneCode = (payload, token) => {
  return post(`${baseUrl}/Clients/phone-verification`, payload, token);
};
const $getUserData = (id, token) => {
  return get(`${baseUrl}/Clients/${id}`, token);
};
const $sendResetPasswordMail = payload => {
  return post(`${baseUrl}/Clients/passwordRecover`, payload);
};
const $reserveWashing = ({ washingPayload, token }) => {
  return post(`${baseUrl}/Washings/reserve`, washingPayload, token);
};
const $getCouponsByUserId = (userId, token) => {
  const filter = encodeURIComponent(
    JSON.stringify({ where: { client_id: userId } })
  );
  return get(`${adminBaseUrl}/Coupons?filter=${filter}`, token);
};
const $getCouponsByCouponCode = (couponKey, token) => {
  const filter = encodeURIComponent(
    JSON.stringify({ where: { code: couponKey } })
  );
  return get(`${adminBaseUrl}/Coupons?filter=${filter}`, token);
};
const $postCoupon = (couponPayload, token) => {
  return post(`${baseUrl}/Coupons/apply?access_token=${token}`, couponPayload);
};

const $getUsedCoupons = (userId, token) => {
  const filter = encodeURIComponent(
    JSON.stringify({
      where: {
        and: [
          {
            coupons: {
              neq: null
            }
          },
          {
            status: {
              neq: 'cancelled'
            }
          },
          { user_id: userId }
        ]
      }
    })
  );
  return get(`${baseUrl}/Clients/${userId}/washings?filter=${filter}`, token);
};

const $getBraintreeToken = token => {
  return get(`${baseUrl}/Clients/braintreeToken?access_token=${token}`, token);
};
const $getUserVehicles = (id, token) => {
  return get(`${baseUrl}/Clients/${id}/vehicles`, token);
};
const $saveNewVehicle = (userId, model, token) => {
  return post(`${baseUrl}/Clients/${userId}/vehicles`, model, token);
};
const $editVehicle = (userId, model, token) => {
  return put(`${baseUrl}/Clients/${userId}/vehicles/${model.id}`, model, token);
};
const $getUserWashings = (userId, token) => {
  const filter = encodeURIComponent(
    JSON.stringify({
      include: ['vehicle', 'prices'],
      order: ['date desc']
    })
  );
  return get(`${baseUrl}/Clients/${userId}/washings?filter=${filter}`, token);
};

const $getUserId = token => {
  return get(`${baseUrl}/ClientAccessTokens/${token}`, token);
};
const $deleteVehicle = (userId, model, token) => {
  return put(`${baseUrl}/Clients/${userId}/vehicles/${model.id}`, model, token);
};

const $editWashing = (washingId, washingEdits, token) => {
  return patch(`${baseUrl}/Washings/${washingId}`, washingEdits, token);
};

const $deleteWashing = (washingId, token) => {
  return post(`${baseUrl}/Washings/cancel`, washingId, token);
};
const $authorizeFbLogin = ({ facebookUser, fbToken }) => {
  return post(`${servicesBaseUrl}/auth/facebook/token`, {
    ...facebookUser,
    access_token: fbToken
  });
};
const $changePassword = (payload, token) => {
  return post(`${baseUrl}/Clients/change-password`, payload, token);
};

const $getLabels = async (lang = window.navigator.language) => {
  const resourcesUrl = await get(
    `${UserMSBaseUrl}/I18n/ResourceFileUrl/websiteb2c/${lang}`,
    lang
  );
  if (resourcesUrl.fileUrl) {
    return get(resourcesUrl.fileUrl);
  }
};

const $postCustomerService = async payload => {
  const res = await post(`${baseUrl}/Clients/supportEmail`, payload);
  return res;
};

const $postJobsForm = async payload => {
  const res = await post(`${UserMSBaseUrl}/Customer/AcademyJob`, payload);
  return res;
};

const $postAcademyForm = async payload => {
  const res = await post(`${UserMSBaseUrl}/Customer/AcademyJob`, payload);
  return res;
};

const $getBoundaries = async () => {
  const recaptcha = await Vue.prototype.$recaptcha('wowebsite');
  return get(
    `${LocationMSBaseUrl}/Location/Cities/ZonesBoundaries`,
    null,
    recaptcha
  );
};

export {
  $getZoneByCoords,
  $getWashersByZone,
  $getWashersByZoneWashOut2,
  $getBrands,
  $getModelsByBrandId,
  $getVehicleTypes,
  $getPrices,
  $getNations,
  $getProvinces,
  $getCities,
  $postRegistration,
  $postLogin,
  $refreshToken,
  $getAuthToken,
  $verifyEmailRequest,
  $verifyPhoneRequest,
  $verifyEmailCode,
  $verifyPhoneCode,
  $getUserData,
  $sendResetPasswordMail,
  $reserveWashing,
  $getCouponsByUserId,
  $getCouponsByCouponCode,
  $postCoupon,
  $getUsedCoupons,
  $getBraintreeToken,
  $getUserVehicles,
  $saveNewVehicle,
  $patchRegistration,
  $getUserWashings,
  $getUserId,
  $editVehicle,
  $deleteVehicle,
  $editWashing,
  $deleteWashing,
  $authorizeFbLogin,
  $changePassword,
  $getLabels,
  $postCustomerService,
  $postJobsForm,
  $postAcademyForm,
  $getPackagesAndServices,
  $getCountries,
  $getBoundaries
};
